import { AppService } from "app/services/app.service";

import { Observable } from "rxjs";

export abstract class AbBlocoPsim extends AppService {
  abstract findAll();
  abstract salvar(lista: any): Observable<any>;
}